import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Loader } from '@googlemaps/js-api-loader';

export class GoogleMapsSnappedPoints {  
  location: {
    latitude: number,
    longitude: number
  };
  originalIndex: number;
  placeId: string;
}

declare const environment;

@Injectable()
export class MapService {
  readonly MaxZoom: number = 20;
  private loader: Loader;
  private loaderPromise: Promise<typeof google>;
  private apiLoaded = false;

  constructor(private httpClient: HttpClient) {
    this.loader = new Loader({
      apiKey: environment.googleMapsApiKey,
      version: 'weekly',
      libraries: ['geometry', 'drawing', 'visualization', 'marker'],
    });
   }

  snapToRoads(path: string, interpolate?: boolean): Observable<{snappedPoints: GoogleMapsSnappedPoints[]}> {
    if (!interpolate) { interpolate = false; }
    return this.httpClient.get<{snappedPoints: GoogleMapsSnappedPoints[]}>(
      'https://roads.googleapis.com/v1/snapToRoads', {
        params: {
          key: environment.googleMapsApiKey,
          interpolate: interpolate.toString(),
          path
        }
      }
    );
  }

  load(): Promise<boolean> {
    if (this.apiLoaded) return Promise.resolve(true);
    return new Promise((resolve) => {
      if (typeof google !== 'undefined' && google.maps) {
        this.apiLoaded = true;
        resolve(true);
        return;
      }
      if (!this.loaderPromise) {
        this.loaderPromise = this.loader.load();
      }
      
      this.loaderPromise.then(() => {
        this.apiLoaded = true;
        resolve(true);
      }).catch((error) => {
        console.error('Error loading Google Maps:', error);
        resolve(false);
      });
    });
  }
}